import { defineComponent as _defineComponent } from 'vue'
import { Ref, ref, watch } from 'vue';
import type { CSwitchOption } from '.';


export default /*#__PURE__*/_defineComponent({
  __name: 'CSwitch',
  props: {
    value: null,
    options: null
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'input', value: string | number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    value?: string | number;
    options: CSwitchOption[];
};





const _model: Ref<number | string> = ref(props.value || props.options[0].value);

const onOptionSelected = (option: CSwitchOption) => {
    if (_model.value == option.value) return;
    _model.value = option.value;
    emit('input', option.value);
};

watch(
    () => props.value,
    (value) => {
        if (value && value != _model.value) {
            _model.value = value;
        }
    }
);

return { __sfc: true,props, emit, _model, onOptionSelected }
}

})